import { DisplayMode } from "core/codegen/types";
export var showNav = function (data) {
    var page = data;
    if (page.embed === null)
        return true;
    return page.embed.displayMode !== DisplayMode.Fullscreen;
};
export var hideFooter = function (data) {
    var _a;
    var page = data;
    if (page.embed === null)
        return false;
    return (_a = page.embed.hideFooter) !== null && _a !== void 0 ? _a : false;
};
